module.exports = __webpack_public_path__ + "static/media/logo-white.04ed63f2.png";